module.exports = __webpack_public_path__ + "img/social_value_content3.71f187f8.png";